import React from "react";

// toast
import { toast } from "react-toastify";

class BaseComponent extends React.Component {

  get country() {
    return localStorage.getItem('country');
  }

  useToast(autoClose = 2000, draggable = false) {
    toast.configure({ autoClose, draggable });
  }

  showErrorToast(message, position = toast.POSITION.TOP_LEFT) {
    toast.error(message, { position });
  }

  showSuccessToast(message, position = toast.POSITION.TOP_LEFT) {
    toast.success(message, { position });
  }

  showInfoToast(message, position = toast.POSITION.TOP_LEFT) {
    toast.info(message, { position });
  }

  showWarningToast(message, position = toast.POSITION.TOP_LEFT) {
    toast.warn(message, { position });
  }
}

export default BaseComponent;
